import { UseControllerProps } from 'react-hook-form';

export const PERSIAN_LATTER_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /^[آ-یءچ\u200A\u200C\u200B ]+$/u,
    message: 'فقط حروف فارسی مجاز است',
  },
};
export const ONLY_NUMBERS_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /^[0-9]+$/u,
    message: 'فقط اعداد مجاز است',
  },
};
export const ONLY_NUMBERS_WITH_SEPARATORS_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /^[\d.,،]+$/u,
    message: 'فقط اعداد مجاز است',
  },
};
export const NO_ZERO_RULE: UseControllerProps['rules'] = {
  validate: (value: string) => {
    if (!value) return true;
    const regex = /^(?!0)\d{1,3}(,\d{3})*$/;

    return regex.test(value) || 'عدد نباید با 0 شروع شود';
  },
};
